export default class MediaCardHtml {
    constructor(mediaDocument, url) {
        // eslint-disable-next-line no-undef
        let $globalConfig;

        if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
            $globalConfig = config;
        }
        this._document = mediaDocument;
        this._id = this._document.productId;
        this._title = this._document.name;
        this._image = this._document.image;
        this._type = '';
        this._language = '';
        this._version = '';
        this._docType = this._document.type;
        this._mediaType= '';
        this._mediaType = this._document.MediaType;
        this._url = url;
        this._type = this._docType !== 'video' ? $globalConfig.textResources.productCatalogConnectorConfig.labelForDocumentTypeInBrochurenAndMovies : $globalConfig.textResources.productCatalogConnectorConfig.labelForVideoTypeInBrochurenAndMovies;
        this._language = this._docType === 'IFU' ? this._document.Language : '';
        this._version = this._docType === 'IFU' ? this._document.Version : '';
    }

    _getImageHtml() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;
        const video = this._docType !== 'video' ? '' : '<div class="rfct-media-card__play"><span class="material-icons">play_circle_filled</span><span class="background-fix"></span></div>';

        let img = '';
        let pictureXS = $globalConfig.images.cardPictureXS;
        let pictureMD = $globalConfig.images.cardPictureMD;
        let pictureXL = $globalConfig.images.cardPictureXL;

        if (this._image && this._image.IN !== '') {
            pictureXS = $globalConfig.urls.mediaFilesURL + this._image.WEBXS;
            pictureMD = $globalConfig.urls.mediaFilesURL + this._image.WEBSM;
            pictureXL = $globalConfig.urls.mediaFilesURL + this._image.WEBMD;
        }

        if (this._image) {
            if ('objectFit' in document.documentElement.style === false) {
                img += `<div class="rfct-media-card__content-ie">${video}
                    <picture class="rfct-media-card__image">
                        <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                        <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                        <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                        <img src="${pictureXS}" class="lazy" data-object-fit="contain" >
                    </picture></div>`;
            } else {
                img += `<div class="rfct-media-card__content">${video}
                    <picture class="rfct-media-card__image">
                        <source media="(min-width: 999px)" data-srcset="${pictureXL} 1x, ${pictureXL} 2x">
                        <source media="(min-width: 797px)" data-srcset="${pictureMD} 1x, ${pictureMD} 2x" >
                        <source data-srcset="${pictureXS} 1x, ${pictureXS} 2x" >
                        <img src="${pictureXS}" class="lazy" data-object-fit="contain" >
                    </picture></div>`;
            }
        }

        return img;
    }

    _getButtonHtml() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;
        return this._docType === 'video' ? '' : `<div class="rfct-media-card__buttons">
            <div class="rfct-media-card__button-item">
                <div class="rfct-button rfct-button--link">
                    <span class="rfct-button__inner">
                        <span class="rfct-button__label">${$globalConfig.textResources.productCatalogConnectorConfig.labelForDocumentDownload}</span>
                        <span class="rfct-button__icon material-icons">
                            file_download
                        </span>
                    </span>
                </div>
            </div>
        </div>`;
    }

    _getLinkHtml() {
        // eslint-disable-next-line no-undef
        let link = '';
        if (this._docType === 'video') {
            link = `<a class="ks-link popup-iframe" data-media="iframe" data-btattached="true" onmousedown="_etracker.sendEvent(new et_UserDefinedEvent('${this._document.materialNumber} ${this._title}', 'VID|CATALOG', 'Show', '${this._document.namingConvention}'))" href="${this._url}">`;
        } else if (this._docType === 'IFU') {
            link = `<a target="_blank" onmousedown="_etracker.sendEvent(new et_UserDefinedEvent('${this._document.materialNumber} [${this._language}] ${this._title.replace(/'/g, '\\\'')} - ${this._version}', 'IFU|CATALOG', 'Download', '${this._mediaType}'))" href="${this._url}">`;
        } else {
            link = `<a target="_blank" onmousedown="_etracker.sendEvent(new et_UserDefinedEvent('${this._document.materialNumber} ${this._title.replace(/'/g, '\\\'')}', 'DOC|CATALOG', 'Download', '${this._document.namingConvention}'))" href="${this._url}">`;
        }
        return link;
    }


    toString() {
        return `<div  class="rfct-media-card">
        ${this._getLinkHtml()}
            ${this._getImageHtml()}
            <div class="rfct-product-card-small__inner">
                <span class="rfct-product-card-small__subline">${this._type.toUpperCase()}</span>
                <span class="rfct-product-card-small__headline">${this._title}</span>
                ${this._getButtonHtml()}
            </div>
        </a>
        </div>`;
    }
}
